module.exports = __webpack_public_path__ + "a669fa8a5c4d581910c1b163abe78243.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/logoSound.mp3
// module id = zdxH
// module chunks = 1